import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class QuestionCorrectCounter extends Phaser.GameObjects.Container {
  constructor(scene, counterSprite, count, lblname) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.indicatorName = counterSprite;
    this.maxCount = count;
    this.counter = 0;
    this.indicators = [];

    this.indicatorContainer = this.scene.add.container();
    this.add(this.indicatorContainer);

    let curX = 0;
    for (let i = 0; i < this.maxCount; i++) {
      const item = ABCyaPhaser.Images.addImage(0, 0, `${this.indicatorName}_off`, this.indicatorContainer).setOrigin(0, 0);
      item.x = curX;
      curX += 50;
      this.indicators.push(item);
    }

    this.txt = this.scene.add.bitmapText(0, this.indicatorContainer.getBounds().height + 10, 'asapBoldItalicSmall', ABCyaPhaser.Localization.instance.getLocalizedString('questions.header'), 16);
    this.add(this.txt);

    this.indicatorContainer.x = this.txt.width / 2 - this.indicatorContainer.getBounds().width / 2;
    this.widthRef = this.txt.width;
  }

  updateDisplay(correctCount) {
    const len = this.indicators.length;
    for (let i = 0; i < len; i++) {
      if (i < correctCount) {
        this.indicators[i].setTexture(ABCyaPhaser.Images.DEFAULT_ATLAS, `${this.indicatorName}_on`);
      }
      else {
        this.indicators[i].setTexture(ABCyaPhaser.Images.DEFAULT_ATLAS, `${this.indicatorName}_off`);
      }
    }
  };
}